<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Assign Kontrak Roya</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/notaris">
            <CIcon name="cil-balance-scale" />
            Notaris
          </b-breadcrumb-item>
          <b-breadcrumb-item to="/contract">Kontrak</b-breadcrumb-item>
          <b-breadcrumb-item active>Assign Roya</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-form-card mb-4">
      <CCardBody class="px-3">
        <CRow>
          <CCol class="col-sm-12 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white mb-2">
                <b-input-group-prepend>
                  <b-form-select class="period-by-select custom-input-prepend" v-model="table.periodBy" :options="table.periodOptions" @change="onChangeFilterDate"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="table.periodStart" 
                    :max="table.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="getTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="table.periodEnd" 
                    :min="table.minPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="getTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="table.filterType" :options="table.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-input 
                    maxlength="50" v-if="table.filterType == 'contractNo'" type="text" placeholder="Search" 
                    :value="table.filterValue" @input="table.filterValue = $helper.parseNumber($event)"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                  ></b-form-input>
                  <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="table.filterValue"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="filterTableItems">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="col-sm-12 mt-4">
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
            <template #cell(no)="row">
              {{ $helper.showData(row.index+1, "number") }}.
            </template>
            <template #cell(contractNo)="row">
              {{ $helper.showData(row.value, "string") }}
            </template>
            <template #cell(customerName)="row">
              {{ $helper.showData(row.value, "string") }}
            </template>
            <template #cell(contractDate)="row">
              {{ $helper.showData(row.value, "shortDate") }}
            </template>
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(action)="row">
                <b-form-checkbox
                  :checked="isCheckedItem(row.item.contractId)"
                  @change="onCheckItem($event, row.item.contractId)"
                ></b-form-checkbox>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
        <CRow class="pt-3">
          <CCol class="col-12">
            <CButton color="primary" class="float-right" style="width:7rem" type="submit" :disabled="isSubmitting" @click="prepareAssignContracts">
              <b-spinner small v-if="isSubmitting" />
              {{ isSubmitting ? 'Sedang diproses...' : 'Assign' }}
            </CButton>
            <b-btn variant="secondary" class="mr-2 float-right" @click="$router.push({name: 'Assign Contract List'})">Cancel</b-btn>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <b-modal
      v-model="assignModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CForm>
        <CRow>
          <CCol class="col-12">
            Pilih Notaris dan Nomor MoU yang akan di Assign sebanyak <strong>{{ table.checkedItems.length }}</strong> item kontrak terpilih:
          </CCol>
        </CRow>
        <CRow>
          <CCol class="col-12 mt-3 mb-5">
            <b-form-group
              invalid-feedback="This input is required."
              label-for="modal-mou-assign"
              :state="assignModalData.mou.isValid"
            >
              <multiselect 
                v-model="assignModalData.mou.value" 
                :options="assignModalData.mou.options" 
                :state="assignModalData.mou.isValid"
                :class="{custom_multiselect_invalid: assignModalData.mou.isValid === false}"
                :searchable="false"
                id="modal-mou-assign"
                placeholder="Select an option"
                :showLabels="false"
                openDirection="bottom"
                label="notaryName"
                track-by="mouId"
              >
                <template slot="singleLabel" slot-scope="props">{{ props.option.notaryName }}</template>
                <template slot="option" slot-scope="props">
                  <span>{{ props.option.notaryName }}</span><br>
                  <small>{{ props.option.mouNo }}</small>
                </template>
                <template slot="noResult">No elements found.</template>
                <template slot="afterList" v-if="assignModalData.mou.currentPage < assignModalData.mou.totalPages">
                  <div class="text-center custom-cursor-clickable p-2" @click="appendSelectMou" v-if="assignModalData.mou.isLoaded">
                    <span class="text-muted">Load More</span>
                  </div>
                  <div class="text-center" v-else>
                    <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                  </div>
                </template>
              </multiselect>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow class="mt-5 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="assignModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="assignModalData.isSubmitting" @click="assignMultipleContracts">
              <b-spinner small v-if="assignModalData.isSubmitting" />
              <span v-else>Save</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>
  </CContainer>
</template>


<script>
export default {
  name: 'AssignContractAddRoya',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {

      isSubmitting: false,

      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],

      contract: {
        bussUnit: "",
        custType: "",
        contractType: "",
        officeCode: ""
      },

      notes: {
        value: '',
        isValid: null,
        isRequired: false,
        payloadKey: "notes"
      },

      assignModalData: {
        isShowing: false,
        isSubmitting: false,
        mou: {
          /*
            "mouCode": "string",
            "mouName": "string",
            "mouId": "string
          */
          value: '',
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          payloadKey: "mouId"
        },
      },

      table: {

        isLoaded: false,

        fields: [
          {key: "no", label: "No.", sortable: false},
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "contractDate", label: "Tanggal Kontrak", sortable: true},
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        checkedItems: [],

        filterType: "contractNo",
        filterOptions: [
          { value: "contractNo", text: "No. Kontrak" },
          { value: "customerName", text: "Nama Customer" }
        ],
        filterValue: "",
        periodOptions: [
          { value:"contractDate", text: "Tanggal Kontrak" }
        ],
        periodBy: "contractDate",
        periodStart: null,
        maxPeriodStart: today,
        periodEnd: null,
        minPeriodEnd: '',
        maxPeriodEnd: today,

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    onChangeFilterDate() {
      if (!this.$helper.isEmpty(this.table.periodStart) && !this.$helper.isEmpty(this.table.periodEnd)) {
        this.getTableItems()
      }
    },
    onChangeFilterType() {
      this.table.filterValue = null
    },

    // update datepicker valid dates on change
    onContextPeriodStart() {
      this.table.minPeriodEnd = this.table.periodStart
    },
    onContextPeriodEnd() {
      this.table.maxPeriodStart = this.table.periodEnd
    },

    prepareAssignContracts() {
      if(this.table.checkedItems <= 0) {
        return this.$helper.toastError(this, "Belum ada Kontrak yang terpilih!")
      }
      this.assignModalData.mou.value = ""
      this.assignModalData.mou.isValid = null
      this.assignModalData.isShowing = true
    },
    assignMultipleContracts(event) {
      event.preventDefault()

      let isFormValid = true

      if(this.table.checkedItems <= 0) {
        return this.$helper.toastError(this, "Belum ada Kontrak yang terpilih!")
      }
      if(this.$helper.isEmpty(this.assignModalData.mou.value) && this.assignModalData.mou.isRequired){
        this.assignModalData.mou.isValid = false
        isFormValid = false
      }
      else {
        this.assignModalData.mou.isValid = null
      }

      if (isFormValid) {
        let payload = new FormData()
        payload.append("contractIds", this.table.checkedItems)
        payload.append("mouId", this.assignModalData.mou.value.mouId)
        let postUrl = '/contract/roya/assignMultiple'

        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.assignModalData.isSubmitting = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Assign Kontrak ke Notaris Berhasil!")
              this.table.checkedItems = []
              this.getTableItems()
              this.assignModalData.isShowing = false
            }
            else{
              this.$helper.toastError(this, "Assign Kontrak ke Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Assign Kontrak ke Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Assign Kontrak ke Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.assignModalData.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },

    // populate select mou dropdown dynamically
    populateMou() {
      this.assignModalData.mou.isLoaded = false
      this.assignModalData.mou.totalPages = 0
      this.assignModalData.mou.totalRows = 0
      this.assignModalData.mou.currentPage = 1
      // URL builder
      let getUrl = "/mou/getMouToMultipleAssign"
      let params = {}
      // get content from current page
      params['page'] = (this.assignModalData.mou.currentPage - 1)
      params['size'] = this.assignModalData.mou.perPage
      // get mou data based on parameters
      params['bussUnit'] = this.contract.bussUnit
      params['contractType'] = this.contract.contractType
      params['custType'] = this.contract.custType
      params['officeCode'] = this.contract.officeCode
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.assignModalData.mou.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.assignModalData.mou.options.push(response.data.data.data[i])
            }
            this.assignModalData.mou.totalRows = response.data.data.totalElements
            this.assignModalData.mou.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.assignModalData.mou.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // load more options for select mou dropdown dynamically
    appendSelectMou() {
      this.assignModalData.mou.isLoaded = false
      // URL builder
      let getUrl = "/mou/getMouToMultipleAssign"
      let params = {}
      // get content from next page
      params['page'] = (this.assignModalData.mou.currentPage)
      params['size'] = this.assignModalData.mou.perPage
      // get mou data based on parameters
      params['bussUnit'] = this.contract.bussUnit
      params['contractType'] = this.contract.contractType
      params['custType'] = this.contract.custType
      params['officeCode'] = this.contract.officeCode
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.assignModalData.mou.options.push(response.data.data.data[i])
            }
            this.assignModalData.mou.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.assignModalData.mou.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    filterTableItems(event) {
      event.preventDefault()
      this.getTableItems()
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/contract/roya/getContractToMultipleAssign"
      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }

      if (!this.$helper.isEmpty(this.contract.bussUnit)) params['bussUnit'] = this.contract.bussUnit
      if (!this.$helper.isEmpty(this.contract.custType)) params['custType'] = this.contract.custType
      if (!this.$helper.isEmpty(this.contract.officeCode)) params['officeCode'] = this.contract.officeCode

      if(!this.$helper.isEmpty(this.table.filterValue)) {
        params['filterType'] = this.table.filterType
        params['filterValue'] = this.table.filterValue
      }

      if (!this.$helper.isEmpty(this.table.periodStart) && !this.$helper.isEmpty(this.table.periodEnd)) {
        params['periodBy'] = this.table.periodBy
        params['periodStart'] = this.table.periodStart
        params['periodEnd'] = this.table.periodEnd
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterAssignContractAddRoyaFilterType" + String(this.$route.params.contractParams), this.table.filterType)
          sessionStorage.setItem("filterAssignContractAddRoyaFilterValue" + String(this.$route.params.contractParams), this.table.filterValue)
          sessionStorage.setItem("filterAssignContractAddRoyaPeriodBy" + String(this.$route.params.contractParams), this.table.periodBy)
          sessionStorage.setItem("filterAssignContractAddRoyaPeriodStart" + String(this.$route.params.contractParams), this.table.periodStart)
          sessionStorage.setItem("filterAssignContractAddRoyaPeriodEnd" + String(this.$route.params.contractParams), this.table.periodEnd)
          this.table.items = response.data.data.data.map(item => {
            return {
              contractId: item.contractId,
              contractNo: item.contractNo,
              customerName: item.customerName,
              contractDate: item.contractDate,
              checkboxState: false
            }
          })
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      this.getTableItems(this.table.currentPage)
    },
    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      this.getTableItems()
    },
    onPageChange(newPage) {
      this.getTableItems(newPage)
    },

    isCheckedItem(contractId) {
      // find in array
      return this.table.checkedItems.includes(contractId)
    },
    onCheckItem(checked, contractId) {
      if(checked){
        // add to array
        this.table.checkedItems.push(contractId)
      }
      else{
        // seek and remove from array
        const idx = this.table.checkedItems.indexOf(contractId)
        if (idx > -1) this.table.checkedItems.splice(idx, 1)
      }
    }
  },
  computed: {
  },
  mounted() {
    let params = this.$route.params.contractParams.split("-")
    if(params.length != 2){
      this.$helper.toastError(this, "Halaman gagal dibuka, terjadi kesalahan saat membaca URL.")
      this.table.isLoaded = true
      return
    }
    if(params[0].length < 7){
      this.$helper.toastError(this, "Halaman gagal dibuka, terjadi kesalahan saat membaca URL.")
      this.table.isLoaded = true
      return
    }
    this.contract.bussUnit = params[1]
    this.contract.custType = params[0].charAt(0)
    this.contract.contractType = params[0].charAt(1)
    this.contract.officeCode = params[0].substring(2, 7)
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAssignContractAddRoyaPeriodBy" + String(this.$route.params.contractParams)))){
      this.table.periodBy = sessionStorage.getItem("filterAssignContractAddRoyaPeriodBy" + String(this.$route.params.contractParams))
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAssignContractAddRoyaPeriodStart" + String(this.$route.params.contractParams)))){
      this.table.periodStart = sessionStorage.getItem("filterAssignContractAddRoyaPeriodStart" + String(this.$route.params.contractParams))
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAssignContractAddRoyaPeriodEnd" + String(this.$route.params.contractParams)))){
      this.table.periodEnd = sessionStorage.getItem("filterAssignContractAddRoyaPeriodEnd" + String(this.$route.params.contractParams))
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAssignContractAddRoyaFilterType" + String(this.$route.params.contractParams)))){
      this.table.filterType = sessionStorage.getItem("filterAssignContractAddRoyaFilterType" + String(this.$route.params.contractParams))
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAssignContractAddRoyaFilterValue" + String(this.$route.params.contractParams)))){
      this.table.filterValue = sessionStorage.getItem("filterAssignContractAddRoyaFilterValue" + String(this.$route.params.contractParams))
    }
    this.getTableItems()
    this.populateMou()
  },
  created(){
  }
}
</script>

<style>

</style>
